import {createSvgIcon} from '../create-svg-icon';

export const NotesIcon = createSvgIcon(
  <path d="M21 11.01 3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z" />
, 'NotesOutlined');
